import Attom from "../../assets/logos/Attom.svg";
import DataAxle from "../../assets/logos/DataAxle.svg";
import Powerlytics from "../../assets/logos/Powerlytics.svg";
import Quantarium from "../../assets/logos/Quantarium.svg";
import Seon from "../../assets/logos/Seon.svg";
import Telesign from "../../assets/logos/Telesign.svg";
import Equifax from "../../assets/logos/Equifax.svg";
import Ekata from "../../assets/logos/Ekata.svg";
import { LinkButton } from "../../../views/components/LinkButton";
import { linksConstants } from "../../../../constants/linksConstants";
import Image from "next/image";

const localProviders = [
  {
    img: Attom,
    name: "Attom",
    url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Attom`,
  },
  {
    img: DataAxle,
    name: "Data Axle",
    url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Data Axle`,
  },
  {
    img: Powerlytics,
    name: "Powerlytics",
    url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Powerlytics`,
  },
  {
    img: Quantarium,
    name: "Quantarium",
    url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Quantarium`,
  },
  {
    img: Seon,
    name: "Seon",
    url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Seon`,
  },
  {
    img: Telesign,
    name: "Telesign",
    url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Telesign`,
  },
  {
    img: Equifax,
    name: "Equifax",
    url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Equifax`,
  },
  {
    img: Ekata,
    name: "Ekata",
    url: `${linksConstants.DATA_CATALOG_CONNECTORS}?data_source=Ekata`,
  },
];

export const DataProviders = ({ providers = localProviders }) => {
  return (
    <section className="home_data_providers-background">
      <div className="home_data_providers">
        <section className="section-layout">
          <h2>Access hundreds of data providers from a single API</h2>
          <p className="home_data_providers-text">
            Demyst provides seamless access to the most valuable data across the globe about
            Businesses, People, Property and Automotive, for Financial Services, Insurance, Buy Now
            Pay Later, and more. Here are just a few examples from our wide-ranging connector:
          </p>
          <div className="home_data_providers-grid">
            {providers.map(({ img, name, url }) => (
              <a key={name} href={url}>
                <div className="home_data_providers-card" key={name}>
                  <div className="img-container">
                    <Image src={img.src} alt={""} loading="lazy" width="80" height="80" />
                  </div>
                  <h3>{name}</h3>
                  <span className="home_data_providers-card-btndummy">View in Catalog</span>
                </div>
              </a>
            ))}
          </div>
          <div className="home_data_providers-banner">
            <p>Browse hundreds of data providers</p>
            <LinkButton variant="inverted" href={linksConstants.DATA_CATALOG_HOME}>
              View Connectors
            </LinkButton>
          </div>
        </section>
      </div>
    </section>
  );
};
